import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/hero.mp4")